import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { REFERRAL_URL, trackReferralClick } from '../utils/tracking';
type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'sm' | 'md' | 'lg';
interface ReferralButtonProps {
  children: React.ReactNode;
  location: string;
  variant?: Variant;
  size?: Size;
  showArrow?: boolean;
  className?: string;
}
const variants: Record<Variant, string> = {
  primary: 'bg-brand text-black hover:bg-brand-hover shadow-[0_14px_44px_-16px_rgba(247,162,59,0.75)]',
  secondary: 'glass text-white hover:border-brand/50 hover:text-brand-hover',
  ghost: 'border border-hairline text-ink-muted hover:text-white hover:border-white/25'
};
const sizes: Record<Size, string> = {
  sm: 'h-10 px-4 text-[13px]',
  md: 'h-12 px-6 text-sm',
  lg: 'h-14 px-8 text-[15px]'
};
export function ReferralButton({
  children,
  location,
  variant = 'primary',
  size = 'md',
  showArrow = false,
  className = ''
}: ReferralButtonProps) {
  const label = typeof children === 'string' ? children : location;
  return <a href={REFERRAL_URL} target="_blank" rel="noopener noreferrer sponsored" onClick={() => trackReferralClick(location, label)} className={`group inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold uppercase tracking-[0.06em] transition-[background-color,border-color,color,transform,box-shadow] duration-200 ease-smooth active:scale-[0.985] ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-234" data-mp="1lye65l8j0geh">
      {children}
      {showArrow && <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-235" data-mp="1zxnkefd690ft" />}
    </a>;
}